import { runTracking } from './tracking';
export { runTracking } from './tracking';
export type { TrackingConfig } from './types';

if (typeof window !== 'undefined') {
  runTracking();
}
